exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "configuration-list md-card{width:98%;min-width:800px}configuration-list md-select.md-table-select>.md-select-value>span>.md-text{display:inline-block!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./sources/components/configurations/configuration-list/configuration-list.scss
// module id = 268
// module chunks = 0